import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'projects/back-office/src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PendingActionsService {
  private http = inject(HttpClient);

  private pendingActionsEndpoint = `${environment.backendServer}/reports/pending-approvals`;

  private pendingActionsUpdated = new BehaviorSubject<PendingAction[]>([]);

  getPendingActions(): Observable<PendingAction[]> {
    return this.http.get<PendingAction[]>(this.pendingActionsEndpoint);
  }

  updatePendingActions(): void {
    this.getPendingActions().subscribe((actions: PendingAction[]) => {
      this.pendingActionsUpdated.next(actions);
    });
  }

  getPendingActionsUpdatedListener(): Observable<PendingAction[]> {
    return this.pendingActionsUpdated.asObservable();
  }
}

export interface PendingAction {
  name: string;
  count: string;
  extras: any;
}
